/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from "react";
import { Loading } from "@networkraildigitalfactory/components";
import PerformanceTable from "./MyPerformanceTable";
import Pagination from "../Pagination/PaginationPage";
import { useMyPerformance } from "../../hooks/useAPI";
import styles from "./MyPerformanceContent.module.css";
import { getCurrentFinancialYear } from "../../services/utils";

const PerformancesContent = (props) => {
  const [loading, setLoading] = useState(false);
  const { isLineManagerView, employeeEmail } = props;
  const [performances, setPerformances] = useState();
  const headings = ["", "Interim Prep", "Interim Complete", "EOY Prep", "EOY Complete"];
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(3);
  const url = isLineManagerView ? `adminPaginated/${pageNumber}` : `Paginated/${pageNumber}`;

  const [{ loading: performanceTableLoading }, executePost] = useMyPerformance(
    {
      method: "POST",
    },
    { manual: true }
  );

  const fetchData = async () => {
    try {
      setLoading(true);
      const dataToSend = {
        employeeEmail,
        limit: pageSize,
        sort: "-1",
      };

      const result = await executePost({
        url,
        data: dataToSend,
      });
      setPerformances(result?.data);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setLoading(false);
    }
  };

  const searchObj = {
    limit: pageSize,
  };

  /*
  Perform a check on the financial year which will run
  in the use effect to ensure table only renders
  once data is available in database
  */
  // variable to hold the exisiting fy
  const existingFinancialYear = [];
  const financialYearCheck = () => {
    performances?.data?.forEach((performance) => {
      existingFinancialYear.push(performance.financialYear);
    });
  };
  useEffect(() => {
    fetchData(searchObj);
  }, [pageNumber, pageSize]);

  useEffect(() => {
    // run financialYearCheck to ensure the variable is accessed
    financialYearCheck();

    if (pageNumber === 1 && !existingFinancialYear.includes(getCurrentFinancialYear())) {
      setTimeout(function () {
        fetchData();
      }, 300);
    }
  }, [performances?.data]);

  const tableData = [];

  const onPageChange = (page) => {
    setLoading(true);
    setPageNumber(page);
  };

  const onPageSizeChange = (size) => {
    setLoading(true);
    setPageSize(size);
    setPageNumber(1);
  };

  const makeTableData = () => {
    performances?.data?.forEach((item) => {
      const tableItem = {
        id: item._id,
        FinancialYear: item.financialYear,
        // Interim Prep
        isInterimPrepStarted:
          !item.interim || !item.interim.interimPrep
            ? false
            : item.interim.interimPrep.isInterimPrepStarted,
        isInterimPrepCompleted:
          !item.interim || !item.interim.interimPrep
            ? false
            : item.interim.interimPrep.isInterimPrepCompleted,
        // LM Completing Interim Prep
        isInterimCompleted: !item.interim ? false : item.interim.isInterimCompleted,
        // EOY Prep
        isEOYPrepStarted:
          !item.eoy || !item.eoy.eoyPrep ? false : item.eoy.eoyPrep.isEoyPrepStarted,
        isEOYPrepCompleted:
          !item.eoy || !item.eoy.eoyPrep ? false : item.eoy.eoyPrep.isEoyPrepCompleted,
        // LM Completing EOY
        isEOYCompleted: !item.eoy ? false : item.eoy.isEoyCompleted,
      };
      tableData.push(tableItem);
    });
    return tableData;
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Loading loading={loading} />
        {!performanceTableLoading && !loading && (
          <>
            <div className={`${styles.row_main} ${styles.objectives_table_row}`}>
              <PerformanceTable
                colHeadings={headings}
                tableData={makeTableData()}
                isLineManagerView={isLineManagerView}
                employeeEmail={employeeEmail}
                financialYear={getCurrentFinancialYear()}
              />
            </div>
            <div className={styles.row_pagination}>
              <Pagination
                onChange={onPageChange}
                currentPage={pageNumber}
                total={performances?.total}
                pageSize={pageSize}
                onPageSizeChange={onPageSizeChange}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PerformancesContent;
